import { openDB } from "idb";
import { api } from "@/lib/api";

const dbPromise = openDB("sitecontrol", 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains("outbox")) db.createObjectStore("outbox", { keyPath: "op_id" });
  },
});

const listeners = new Set();
export function onOutboxChange(cb) { listeners.add(cb); return () => listeners.delete(cb); }
async function notify() { const n = await pendingCount(); listeners.forEach((l) => l(n)); }

export async function pendingCount() {
  const db = await dbPromise;
  return (await db.getAllKeys("outbox")).length;
}

const MAX_PHOTO_OPS = 20;

export async function queueOp(type, payload) {
  const db = await dbPromise;
  let capped = false;
  if (type === "photo_upload") {
    const all = await db.getAll("outbox");
    const photos = all.filter((o) => o.type === "photo_upload").sort((a, b) => a.queued_at - b.queued_at);
    while (photos.length >= MAX_PHOTO_OPS) {
      const oldest = photos.shift();
      await db.delete("outbox", oldest.op_id);
      capped = true;
    }
  }
  const rec = { op_id: (crypto.randomUUID ? crypto.randomUUID() : String(Date.now() + Math.random())), type, payload, queued_at: Date.now() };
  await db.put("outbox", rec);
  await notify();
  return { ...rec, capped };
}

export async function flush() {
  const db = await dbPromise;
  const ops = await db.getAll("outbox");
  if (!ops.length) return { synced: 0 };
  const operations = ops.map((o) => ({ op_id: o.op_id, type: o.type, payload: o.payload }));
  const { data } = await api.post("/sync/batch", { operations });
  for (const r of data.results) {
    if (r.status !== "error" && r.op_id) await db.delete("outbox", r.op_id);
  }
  await notify();
  return { synced: data.results.filter((r) => r.status !== "error").length };
}

// Run a mutation online, or queue it when offline. Returns true if executed live.
export async function runOrQueue(type, payload, liveCall) {
  if (navigator.onLine) {
    await liveCall();
    return true;
  }
  await queueOp(type, payload);
  return false;
}

let started = false;
export function initSync() {
  if (started) return;
  started = true;
  window.addEventListener("online", () => flush().catch(() => {}));
  if (navigator.onLine) flush().catch(() => {});
}
